import { render, staticRenderFns } from "./ActivityBase.vue?vue&type=template&id=6ff6a631&scoped=true&lang=pug&"
import script from "./ActivityBase.vue?vue&type=script&lang=js&"
export * from "./ActivityBase.vue?vue&type=script&lang=js&"
import style0 from "./ActivityBase.vue?vue&type=style&index=0&id=6ff6a631&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff6a631",
  null
  
)

export default component.exports